import {
  Avatar as ChakraAvatar,
  type AvatarRootProps,
  type AvatarFallbackProps,
} from "@chakra-ui/react";
import { PickPalette } from "../../helpers/color";

export interface AvatarProps {
  // Required
  name: string;

  /** Optional photo; falls back to initials when absent or it fails to load. */
  src?: string;
  /** Override the auto-derived initials (e.g. to show first-name initials). */
  initials?: string;

  // Root props
  colorPalette?: AvatarRootProps["colorPalette"];
  rootProps?: Omit<AvatarRootProps, "colorPalette">;

  // Fallback props
  fallbackProps?: AvatarFallbackProps;
}

export const Avatar = ({
  name,
  src,
  initials,
  colorPalette,
  rootProps = {},
  fallbackProps = {},
}: AvatarProps) => {
  // Use PickPalette if colorPalette not provided
  const palette = colorPalette || PickPalette(name);

  return (
    <ChakraAvatar.Root
      w={"32px"}
      h={"32px"}
      colorPalette={palette}
      {...rootProps}
    >
      {src ? <ChakraAvatar.Image src={src} /> : null}
      {initials ? (
        <ChakraAvatar.Fallback {...fallbackProps}>
          {initials}
        </ChakraAvatar.Fallback>
      ) : (
        <ChakraAvatar.Fallback name={name} {...fallbackProps} />
      )}
    </ChakraAvatar.Root>
  );
};
